module.exports = __webpack_public_path__ + "img/20210701_172412.2f7db98c.jpg";